import {
  OrganismeDetailsDto,
  OrganismeProjection,
  useGetOrganismeQuery,
  UtilisateurDto,
  UtilisateurRole,
} from '@common/services';
import { groupBy } from '@common/utils';
import { useMemo } from 'react';

export function useOfaDetails(args: UseOfaDetailsConfig) {
  const { id } = args;

  const { data: organisme, isLoading } = useGetOrganismeQuery({
    id,
    projection: OrganismeProjection.DETAILS,
  }, { skip: !id });

  const usersMap = useMemo(
    () => groupBy<UtilisateurRole, UtilisateurDto>('role', organisme?.utilisateurs),
    [organisme]);

  return {
    organisme: organisme as OrganismeDetailsDto,
    isLoading,
    usersMap,
  };
}

interface UseOfaDetailsConfig {
  id: number | undefined;
}